<div class="toolbar-item" [pTooltip]="i18n?.i18nLng()[i18nTooltipKey] ? i18n?.i18nLng()[i18nTooltipKey] : tooltipText" tooltipPosition="left">
  @if (icon === 'AVATAR') {
    <div class="avatar">
      {{ authService?.userData?.avatar }}
    </div>
  } @else {
    @if (!showBadge) {
      <i class="pi" [ngClass]="icon" [ngStyle]="{'font-size':size}"></i>
    } @else {
      <p-overlayBadge badgeSize="small"
                      [value]="badgeValue"
                      [severity]="severity">
        <i class="pi" [ngClass]="icon" [ngStyle]="{'font-size':size}"></i>
      </p-overlayBadge>
    }
  }
</div>
